<template>
    <template v-if="shouldShow">
        <div class="d-flex align-center">
            <v-menu @mouseenter="handleHover" offset-y>
                <template #activator="{ props: menuProps }">
                    <v-tooltip location="left">
                        <template #activator="{ props: tooltipProps }">
                            <v-btn
                                icon
                                size="x-large"
                                elevation="3"
                                :color="color"
                                v-bind="{ ...menuProps, ...tooltipProps }"
                                density="compact"
                            >
                                <template v-if="iconType === 'mdi'">
                                    <v-icon v-bind="iconColor ? { color: iconColor } : {}">{{ icon }}</v-icon>
                                </template>
                                <template v-else-if="iconType === 'img'">
                                    <img
                                        :src="icon"
                                        alt="App Icon"
                                        width="24"
                                        height="24"
                                    />
                                </template>
                            </v-btn>
                        </template>
                        <span>{{ tooltipText }}</span>
                    </v-tooltip>
                </template>

                <v-list>
                    <v-list-item @click.stop="primaryAction(phone)">
                        <v-list-item-title>
                            {{ $t("entries.contactUser") }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click.stop="secondaryAction()">
                        <v-list-item-title>
                          {{ secondaryActionLabel }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>
    </template>
</template>

<script>
export default {
    name: "MessagingButton",
    props: {
        uid: {
            type: String,
            required: true,
        },
        formType: {
            type: String,
            required: true,
        },
        userHasApp: {
            type: Boolean,
            required: true,
        },
        phone: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
        iconType: {
            type: String,
            default: "mdi", // 'mdi' or 'img'
        },
        tooltipText: {
            type: String,
            required: true,
        },
        primaryAction: {
            type: Function,
            required: true,
        },
        secondaryAction: {
            type: Function,
            required: true,
        },
        secondaryActionLabel: {
            type: String,
            required: true,
        },
        iconColor: {
            type: String,
            default: null,
        },
    },
    computed: {
        shouldShow() {
            return this.formType && this.userHasApp;
        },
    },
    methods: {
        handleHover() {
            this.$emit("hoverStart", this.uid);
        },
    },
};
</script>
